import React from 'react';
import { Star } from 'lucide-react';

const LeaveReviewSection = ({ locations, dynamicLocations }) => {
  return (
    <section className="py-16 px-6 bg-gradient-to-r from-yellow-50 to-amber-50">
      <div className="container mx-auto">
        <div className="text-center mb-10">
          <Star className="w-12 h-12 mx-auto mb-4 text-yellow-500 fill-yellow-500" />
          <h2 className="text-3xl md:text-4xl font-bold text-chocolate mb-3">¿Te gustaron nuestros postres?</h2>
          <p className="text-lg text-chocolate-light max-w-xl mx-auto">
            ¡Tu opinión es muy importante para nosotros! Déjanos una reseña en Google y ayúdanos a seguir mejorando.
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 gap-6 max-w-3xl mx-auto">
          {locations.map((location) => {
            // Get dynamic data from API if available
            const dynamicData = dynamicLocations?.find(l => l.id === location.id);
            const rating = dynamicData?.googleRating ?? location.googleRating;
            const reviewCount = dynamicData?.googleReviews ?? location.googleReviews;
            
            return (
              <a 
                key={location.id}
                href={location.googleReviewUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="group bg-white rounded-2xl p-6 shadow-lg hover:shadow-2xl transition-all duration-300 border-2 border-transparent hover:border-yellow-400 transform hover:scale-105"
              >
                <div className="flex items-center justify-between mb-4">
                  <div>
                    <h3 className="text-xl font-bold text-chocolate">{location.name}</h3>
                    <p className="text-sm text-chocolate-light">{location.address.split(',')[0]}</p>
                  </div>
                  <div className="flex items-center gap-1 bg-gradient-to-r from-yellow-100 to-yellow-50 px-3 py-2 rounded-full shadow-sm">
                    <Star className="w-5 h-5 text-yellow-500 fill-yellow-500" />
                    <span className="font-bold text-yellow-700 text-lg">{rating}</span>
                    <span className="text-sm text-yellow-600 font-medium">({reviewCount})</span>
                  </div>
                </div>
                
                <div className="flex items-center justify-between">
                  <div className="flex gap-1">
                    {[1,2,3,4,5].map((star) => (
                      <Star 
                        key={star} 
                        className={`w-6 h-6 transition-colors ${star <= Math.round(rating) ? 'text-yellow-500 fill-yellow-500' : 'text-gray-300'}`}
                      />
                    ))}
                  </div>
                  <span className="flex items-center gap-2 bg-blue-600 text-white px-4 py-2 rounded-full font-medium group-hover:bg-blue-700 transition-colors">
                    <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                      <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                      <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
                      <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
                    </svg>
                    Dejar Reseña
                  </span>
                </div>
              </a>
            );
          })}
        </div>
        
        <p className="text-center text-sm text-chocolate-light mt-6">
          ⭐ ¡Cada reseña nos ayuda a crecer! Gracias por tu apoyo.
        </p>
      </div>
    </section>
  );
};

export default LeaveReviewSection;
